import { BaseContainerModel } from '../base-container.model';
import {
    bl_fi_generic_doc_message_template_hdr_RowClass,
    bl_fi_generic_doc_message_template_hdr_RowInterface,
    bl_fi_generic_doc_message_template_line_RowClass,
    bl_fi_generic_doc_message_template_ext_RowClass,
  } from '../../dbschema/index';
export class GenericDocMessageTemplateContainer extends BaseContainerModel {
    bl_fi_generic_doc_message_template_hdr: bl_fi_generic_doc_message_template_hdr_RowInterface = new bl_fi_generic_doc_message_template_hdr_RowClass();
    bl_fi_generic_doc_message_template_ext: bl_fi_generic_doc_message_template_ext_RowClass[] = [];
    bl_fi_generic_doc_message_template_line: bl_fi_generic_doc_message_template_line_RowClass[] = []
}